import $ from 'jquery';


export default function () {
    // refresh banner and 300 x 250 ads every 2 minutes
    setInterval(() => {
        $(window).trigger('fc:videoPlayPassedThreshold');
    }, 2 * 60 * 1000);
}
